import { MutationOptions, useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import { TApiProjectSection, TApiSession } from "../../api-client/types"
import { cloneDeep } from "lodash"

interface Args {
  projectId: string
  projectSectionId: string
}

export const useDeleteProjectSectionMutation = (options?: MutationOptions<any,any,any>) => {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const mutation = useMutation(
    ["delete-project-section"],
    async (args: Args) => {
      const {
        projectId,
        projectSectionId,
      } = args

      const response = await apiClient.deleteProjectSection(projectId, projectSectionId)

      if (!response.ok) {
        throw response.errors
      }

      return response
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['project-sections'], { exact: false })
      }
    }
  )

  return mutation
}

export default useDeleteProjectSectionMutation